import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'; // Import useNavigate and useLocation
import axios from "axios";

axios.defaults.withCredentials = true;

const PaymentHistoryPage = ({ onClose }) => {
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate(); // Initialize navigate function
    const location = useLocation(); // Get current location

    // Get the 'from' prop passed via location state
    const { from } = location.state || {}; // Default to {} in case state is not available

    useEffect(() => {
        const fetchPaymentHistory = async () => {
            try {
              const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/transaction/payment-history`);
              setPaymentHistory(response.data);
            } catch (error) {
              setError('Failed to fetch payment history');
            } finally {
              setLoading(false);
            }
          };
  
      fetchPaymentHistory();
    }, []);
  
    // Handle clicking outside the modal to close it
    const handleOverlayClick = (e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    };
  
    // Handle ESC key press to close modal
    // useEffect(() => {
    //   const handleEscKey = (e) => {
    //     if (e.key === 'Escape') {
    //       onClose();
    //     }
    //   };
  
    //   document.addEventListener('keydown', handleEscKey);
    //   return () => document.removeEventListener('keydown', handleEscKey);
    // }, [onClose]);
  
    // Close button click handler to navigate based on location
    // Close button click handler to navigate based on the 'from' prop
    const handleCloseClick = () => {
        if (from === 'home') {
          navigate('/'); // Redirect to home page
        } else {
          navigate('/dashboard'); // Redirect to dashboard page
        }
      };
  
    return (
      <div 
        className="bg-white p-6 rounded-lg shadow-lg max-w-xl mx-auto relative" 
        onClick={handleOverlayClick} 
      >
        {/* Close Button */}
        <button 
          onClick={handleCloseClick} 
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-3xl"
        >
          &times;
        </button>
  
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Payment History</h2>
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
          </div>
        ) : error ? (
          <div className="text-red-500 text-center py-4">{error}</div>
        ) : paymentHistory.length === 0 ? (
          <div className="text-gray-500 text-center py-4">No payment history available.</div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full table-auto">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left text-sm font-semibold text-gray-600">Amount Paid</th>
                  <th className="px-4 py-2 text-left text-sm font-semibold text-gray-600">Credits Added</th>
                  <th className="px-4 py-2 text-left text-sm font-semibold text-gray-600">Payment Date</th>
                  <th className="px-4 py-2 text-left text-sm font-semibold text-gray-600">Payment Status</th>
                  <th className="px-4 py-2 text-left text-sm font-semibold text-gray-600">Payment ID</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {paymentHistory.map((payment, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-900">{payment.amountPaid}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">{payment.creditsAdded}</td>
                    <td className="px-4 py-3 text-sm text-gray-900">
                      {new Date(payment.paymentDate).toLocaleDateString()}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-900">{payment.paymentStatus}</td>
                    <td className="px-4 py-3 text-sm text-gray-900 font-mono">{payment.paymentId}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };
  
  export default PaymentHistoryPage;
